<template>
  <!-- 直播列表 -->
  <div class="my-live">
    <van-list
      v-model="loading"
      v-if="list.length > 0 && !isNone"
      :finished="finished"
      finished-text="我是有底线的"
      loading-text="正在加载..."
      @load="onLoad"
      class="cons-list"
    >
      <div
        class="flex-con"
        v-for="(item, index) in list"
        :key="index"
        @click="handleJump(item)"
        v-track="{ functionName: '个人中心-我的直播预告列表' }"
      >
        <div class="right-con">
          <img :src="item && item.icon" class="con-cover" alt="" />
        </div>
        <div class="left-con">
          <div class="txt1" :class="curItem === 1 ? 'docu' : ''">
            {{ item && item.title }}
          </div>
          <div class="txt2">
            <span class="span2">{{ item && item.startTxt }}</span>
            <div class="btn">已报名</div>
          </div>
        </div>
      </div>
    </van-list>
    <div class="search-none" v-else-if="list.length <= 0 && isNone">
      <img
        src="@/assets/images/home/empty_state_none@2x.png"
        class="none-img"
        alt=""
      />
      <div class="none-txt">暂无内容</div>
    </div>
    <returnBack></returnBack>
  </div>
</template>
<script>
import {
  listPageMobile,
} from '@/api/person'
import withRouteTracking from '@/utils/withRouteTracking'
import returnBack from '@/views/person/components/returnBack.vue'
const UserProfile = {
  name: 'ArticleList',
  data() {
    return {
      curItem: 0,
      list: [],
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      load: false,
      isNone: false,
    }
  },
  components: {
    returnBack,
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    onLoad() {
      if (this.load) {
        return
      }
      this.load = true
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      params.openId = this.userInfo.iepOpenId
      listPageMobile(params).then((res) => {
        res.data.list.forEach(item => {
          item.startTxt = this.$moment(parseInt(item.start)).format('YYYY-MM-DD HH:mm:ss')
        })
        this.load = false
        if (res.data.list.length < this.pageSize) {
          this.finished = true
        }
        this.list = this.list.concat(res.data.list)
        // 加载状态结束
        this.loading = false
        if (this.list.length <= 0) {
          this.isNone = true
        } else {
          this.isNone = false
        }
        this.pageNum++
      })
    },
    handleJump(item) {
      localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/liveDetails?liveId=${item.id}&entrance=99&channel=99`)
      this.$router.push({
        path: '/liveDetails',
        query: {
          liveId: item.id,
          entrance: 99,
          channel: 99,
        }
      })
    }
  },
}
// 这块是路由跟踪埋点的功能，具体实现在utils/withRouteTracking.js
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.my-live {
  background: #F9F8F7;
  min-height: 100vh;
  width: 100vw;

  .cons-list {
    background-color: #fff;
    border-radius: 12px;
    position: relative;
    top: 20px;
    margin: 0 12px;
    padding: 15px 0;
    box-sizing: border-box;
    overflow-y: scroll;
    height: calc(100vh - 50px);
  }

  .flex-con {
    display: flex;
    justify-content: space-between;
    padding: 0 12px;
    box-sizing: border-box;
    margin-bottom: 16px;
    align-items: center;

    .right-con {
      width: 110px;
      height: 60px;
      margin-right: 10px;
      position: relative;
      border-radius: 5px;
      overflow: hidden;

      .con-cover {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .tag-txt {
        position: absolute;
        width: 30px;
        height: 16px;
        font-size: 10px;
        background-color: #6a7481;
        border-radius: 5px;
        left: 0;
        top: 0;
        text-align: center;
        line-height: 16px;
        color: #fff;
        font-size: 10px;
      }
    }

    .left-con {
      flex: 1;
      width: calc(100% - 110px);

      .txt1 {
        font-size: 14px;
        color: #000000;
        font-weight: 500;
        line-height: 20px;
        margin-bottom: 8px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        &.docu {
          height: 40px;
          white-space: inherit;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .txt2 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #b1b1b1;
        font-size: 12px;

        .span1 {
          width: 130px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .btn {
          width: 65px;
          height: 24px;
          background: #ffefe7;
          border-radius: 13px 13px 13px 13px;
          font-family: Helvetica, Helvetica;
          font-weight: 400;
          font-size: 14px;
          color: #ff5a0b;
          line-height: 23px;
          text-align: center;
        }
      }
    }
  }

  .search-none {
    padding-bottom: 40px;
    box-sizing: border-box;

    .none-img {
      width: 185px;
      margin-left: 50%;
      transform: translateX(-50%);
      margin-top: 150px;
    }

    .none-txt {
      font-size: 12px;
      color: #949ba5;
      text-align: center;
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/person/newLiveList.vue